import { Action } from '@ngrx/store'
import * as FinancialInstitutionsTypes from './financial-institutions.types'
import { FinancialInstitution } from './financial-institutions.interface'

// Fetch FinancialInstitution Types
export class FetchFinancialInstitutionsRequest implements Action {
  readonly type =
    FinancialInstitutionsTypes.FETCH_FINANCIAL_INSTITUTIONS_REQUEST
  constructor(public payload: any = {}) {}
}

export class FetchFinancialInstitutionsSuccess implements Action {
  readonly type =
    FinancialInstitutionsTypes.FETCH_FINANCIAL_INSTITUTIONS_SUCCESS
  constructor(
    public payload: FinancialInstitution[],
    public total: number,
    public results: number,
  ) {}
}

export class FetchFinancialInstitutionsFailure implements Action {
  readonly type =
    FinancialInstitutionsTypes.FETCH_FINANCIAL_INSTITUTIONS_FAILURE
  constructor(public payload: any) {}
}

// Fetch FinancialInstitution Type
export class FetchFinancialInstitutionRequest implements Action {
  readonly type = FinancialInstitutionsTypes.FETCH_FINANCIAL_INSTITUTION_REQUEST
  constructor(public id: number) {}
}

export class FetchFinancialInstitutionSuccess implements Action {
  readonly type = FinancialInstitutionsTypes.FETCH_FINANCIAL_INSTITUTION_SUCCESS
  constructor(public payload: FinancialInstitution) {}
}

export class FetchFinancialInstitutionFailure implements Action {
  readonly type = FinancialInstitutionsTypes.FETCH_FINANCIAL_INSTITUTION_FAILURE
  constructor(public payload: any) {}
}

// Delete FinancialInstitution Type
export class DeleteFinancialInstitutionRequest implements Action {
  readonly type =
    FinancialInstitutionsTypes.DELETE_FINANCIAL_INSTITUTION_REQUEST
  constructor(public id: number) {}
}

export class DeleteFinancialInstitutionSuccess implements Action {
  readonly type =
    FinancialInstitutionsTypes.DELETE_FINANCIAL_INSTITUTION_SUCCESS
  constructor() {}
}

export class DeleteFinancialInstitutionFailure implements Action {
  readonly type =
    FinancialInstitutionsTypes.DELETE_FINANCIAL_INSTITUTION_FAILURE
  constructor(public payload: any) {}
}

// Create FinancialInstitution Type
export class CreateFinancialInstitutionRequest implements Action {
  readonly type =
    FinancialInstitutionsTypes.CREATE_FINANCIAL_INSTITUTION_REQUEST
  constructor(public payload) {}
}

export class CreateFinancialInstitutionSuccess implements Action {
  readonly type =
    FinancialInstitutionsTypes.CREATE_FINANCIAL_INSTITUTION_SUCCESS
  constructor() {}
}

export class CreateFinancialInstitutionFailure implements Action {
  readonly type =
    FinancialInstitutionsTypes.CREATE_FINANCIAL_INSTITUTION_FAILURE
  constructor(public payload: any) {}
}

// Update FinancialInstitution Type
export class UpdateFinancialInstitutionRequest implements Action {
  readonly type =
    FinancialInstitutionsTypes.UPDATE_FINANCIAL_INSTITUTION_REQUEST
  constructor(public id: number, public payload) {}
}

export class UpdateFinancialInstitutionSuccess implements Action {
  readonly type =
    FinancialInstitutionsTypes.UPDATE_FINANCIAL_INSTITUTION_SUCCESS
  constructor() {}
}

export class UpdateFinancialInstitutionFailure implements Action {
  readonly type =
    FinancialInstitutionsTypes.UPDATE_FINANCIAL_INSTITUTION_FAILURE
  constructor(public payload: any) {}
}

// Common

export class UpdateField implements Action {
  readonly type = FinancialInstitutionsTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = FinancialInstitutionsTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | UpdateFinancialInstitutionRequest
  | UpdateFinancialInstitutionSuccess
  | UpdateFinancialInstitutionFailure
  | FetchFinancialInstitutionsSuccess
  | FetchFinancialInstitutionsFailure
  | FetchFinancialInstitutionsRequest
  | FetchFinancialInstitutionSuccess
  | FetchFinancialInstitutionFailure
  | FetchFinancialInstitutionRequest
  | CreateFinancialInstitutionRequest
  | CreateFinancialInstitutionSuccess
  | CreateFinancialInstitutionFailure
  | DeleteFinancialInstitutionRequest
  | DeleteFinancialInstitutionSuccess
  | DeleteFinancialInstitutionFailure
  | SetDefaultData
  | UpdateField
  | FetchFinancialInstitutionsRequest
  | FetchFinancialInstitutionsSuccess
  | FetchFinancialInstitutionsFailure
